import { HTTPError } from './HTTPError'

/**
 * Returns a function to standardise the handling of all HTTP requests using fetch.
 */
export function handleRequest<T>() {
  return (request: Response) => {
    // If everything went well, parse the JSON
    if (request.ok) return request.json() as Promise<T>

    // Otherwise throw an error
    throw new HTTPError(`${request.status}: ${request.statusText}`)
  }
}
